import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query'
import type { ReviewGrade } from '@shared/srs'
import type { ReviewQueue, ReviewResult } from '@shared/types/vocabulary'
import { api } from './api'

export const reviewKeys = {
  due: ['vocabulary', 'due'] as const,
}

export function useReviewQueue() {
  return useQuery({
    queryKey: reviewKeys.due,
    queryFn: () => api<ReviewQueue>('/vocabulary/due'),
    // The queue changes as she works, so it must never be served from cache
    // on a fresh visit to the screen.
    staleTime: 0,
    refetchOnWindowFocus: false,
  })
}

export function useGradeCard() {
  return useMutation({
    mutationFn: (input: { vocabularyId: string; grade: ReviewGrade; durationMs?: number }) =>
      api<ReviewResult>(`/vocabulary/${input.vocabularyId}/review`, {
        method: 'POST',
        body: { grade: input.grade, durationMs: input.durationMs },
      }),
  })
}

export function useFinishReviewSession() {
  const queryClient = useQueryClient()
  return useMutation({
    mutationFn: () => api<{ currentStreak: number }>('/vocabulary/session/finish', {
      method: 'POST',
    }),
    onSuccess: async () => {
      // The dashboard's due count, streak and word stats all just moved.
      await queryClient.invalidateQueries({ queryKey: ['progress'] })
      await queryClient.invalidateQueries({ queryKey: reviewKeys.due })
    },
  })
}
